import { TeamTypeCode } from "@common/ADAPT.Common.Model/organisation/team-type-code";
import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Organisation } from "./organisation";

export class TeamTypeConfiguration extends BaseEntity<TeamTypeConfiguration> {
    public teamTypeConfigurationId!: number;
    public organisationId!: number;
    public name!: string;
    public code?: TeamTypeCode;
    public ordinal!: number;
    public iconColour?: string;
    public backgroundColour?: string;
    public icon?: string;

    public organisation!: Organisation;
}

export const TeamTypeConfigurationBreezeModel = new BreezeModelBuilder("TeamTypeConfiguration", TeamTypeConfiguration)
    .hasSource()
    .isOrganisationEntity()
    .withSortField("ordinal")
    .build();
